import { render } from "./login-redirection.vue?vue&type=template&id=146b0091&scoped=true"
import script from "./login-redirection.vue?vue&type=script&lang=js"
export * from "./login-redirection.vue?vue&type=script&lang=js"

import "./login-redirection.vue?vue&type=style&index=0&id=146b0091&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146b0091"]])

export default __exports__